import { z } from 'zod';
export var FollowUpTools;
(function (FollowUpTools) {
    FollowUpTools["GENERATE_TABLE"] = "generate_table";
    FollowUpTools["GENERATE_BAR_VIZ"] = "generate_bar_viz";
    FollowUpTools["GENERATE_TIME_SERIES_VIZ"] = "generate_time_series_viz";
})(FollowUpTools || (FollowUpTools = {}));
export const followUpToolsText = {
    [FollowUpTools.GENERATE_TABLE]: 'Generate a Table',
    [FollowUpTools.GENERATE_BAR_VIZ]: 'Generate a Bar Chart',
    [FollowUpTools.GENERATE_TIME_SERIES_VIZ]: 'Generate a Time Series Chart',
};
export const followUpToolsSchema = z.nativeEnum(FollowUpTools).array();
//# sourceMappingURL=followUpTools.js.map